import { utils } from '@hh/global.js'

class DeferredMedia extends HTMLElement {
  constructor() {
    super()

    this.loadContent = this.loadContent.bind(this)
  }

  addEventListeners() {
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      'click',
      this.loadContent.bind(this)
    )
  }

  disconnectedCallback() {
    this.querySelector('[id^="Deferred-Poster-"]')?.removeEventListener(
      'click',
      this.loadContent
    )
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)

      utils.pauseAllMedia()

      this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      ).focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)
